import NotFoundPage from '@/pages/not-found.page';
import { createFileRoute } from '@tanstack/react-router';

// Catch-all for `/settings/billing/*` sub-paths that no tab route matches. Every billing tab is
// migrated and has its own route, so an unmatched sub-path is a bad URL, not a tab still served by
// the embedded app — this used to hand those to the embedded host, which rendered a second app
// inside the Hydra billing shell.
//
// The `/settings/billing` subtree is Hydra-owned as one unit behind the billing flag: with the flag
// off, `BillingRoute` short-circuits to the embedded host before this can render.
export const Route = createFileRoute('/_authenticated/settings/billing/$')({
  component: NotFoundPage,
});
